import {
	VEHICLE_STATUS_BY_ID_COLORS,
	VEHICLE_STATUS_BY_ID_LABELS,
} from "../constants";
import type { EditVehicleSituation } from "../types";

export const editVehicleSituationLabel = (situation: EditVehicleSituation) =>
	VEHICLE_STATUS_BY_ID_LABELS[situation];

export const editVehicleSituationColor = (situation: EditVehicleSituation) =>
	VEHICLE_STATUS_BY_ID_COLORS[situation];
